import fetch from "../../uilts/request.js";

export default {
    getList(data) {
        return fetch.post("/MemberRealname/getList",data)
    },
    getRealnameDetails(data) {
        return fetch.post("/MemberRealname/getRealnameDetails",data)
    },
    compress(data) {
        return fetch.post("/MemberRealname/compress",data)
    },
    submit(data) {
        return fetch.post("/MemberRealname/submit",data)
    },
    againName(data){
        return fetch.post("/MemberRealname/againName",data)
    }


}
